"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("./"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Modal/content.js";
function noop() {}
var defaultProps = {
  positiveButton: 'YES',
  negativeButton: 'CANCEL',
  onPositiveClick: noop,
  onNegativeClick: noop,
  footer: true,
  size: 'md'
};
function ModalContent(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    onClosed = _ref.onClosed,
    size = _ref.size,
    positiveButton = _ref.positiveButton,
    negativeButton = _ref.negativeButton,
    onPositiveClick = _ref.onPositiveClick,
    onNegativeClick = _ref.onNegativeClick,
    footer = _ref.footer,
    className = _ref.className,
    closable = _ref.closable;
  var _React$useState = _react["default"].useState(isOpen),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  _react["default"].useEffect(function () {
    setOpen(isOpen);
  }, [isOpen]);
  var style = {
    minWidth: '6em'
  };
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    isOpen: open,
    onClosed: onClosed,
    size: size,
    closable: closable,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement(_["default"].Body, {
    className: (0, _classNames["default"])("p-0", className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 13
    }
  }, children), footer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer border-0 p-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    style: style,
    onClick: function onClick() {
      setOpen(false);
      onPositiveClick();
    },
    type: "submit",
    className: "btn btn-primary fs-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 21
    }
  }, positiveButton), negativeButton && /*#__PURE__*/_react["default"].createElement("button", {
    style: style,
    onClick: function onClick() {
      setOpen(false);
      onNegativeClick();
    },
    type: "button",
    className: "btn btn-light fs-sm ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 29
    }
  }, negativeButton)));
}
ModalContent.defaultProps = defaultProps;
var _default = ModalContent;
exports["default"] = _default;